import { CdkStep, StepControl } from '@angular/cdk/stepper';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';

@Component({
  selector: 'procure-wizard-step',
  templateUrl: './wizard-step.component.html',
  providers: [{ provide: CdkStep, useExisting: WizardStep }],
  host: { hidden: '' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizardStep extends CdkStep {
  readonly description = input<string>('');
  readonly completedOverride = computed(() => this._completedOverride());
  readonly control = computed(() => {
    this.revision();

    return this.stepControl as StepControl | undefined;
  });

  private readonly revision = signal(0);

  override ngOnChanges(): void {
    super.ngOnChanges();
    this.revision.update((revision) => revision + 1);
  }
}
